// extracted by mini-css-extract-plugin
module.exports = {"root":"Usp_root__prrA9","title":"Usp_title__3gLkm","list":"Usp_list__3MORI","usp_list":"Usp_usp_list__3h4Cm","icon":"Usp_icon__29NR-"};